export const validateFile = (
  file: File,
  acceptedFileTypes: string[],
  maxFileSizeInMB: number
): string[] => {
  const errors: string[] = [];

  if (!acceptedFileTypes.includes(file.type)) {
    errors.push('Unsupported file type.');
  }

  if (file.size > maxFileSizeInMB * 1024 * 1024) {
    errors.push('File too big.');
  }

  return errors;
};
